import { initialState, UserToBillState } from "./state";
import { Actions } from './actions';
import { USER_TO_BILL_LIST, SAVE_USER_TO_BILL_RESP, DELETE_USER_TO_BILL_RESP } from "./actionTypes";

export function UserToBillReducer(state = initialState, action: Actions): UserToBillState {
    switch (action.type) {
        case USER_TO_BILL_LIST:
            return Object.assign({}, state, {
                userToBillList: action.payload
            });
        case SAVE_USER_TO_BILL_RESP:
            return Object.assign({}, state, {
                saveUserToBillResp: action.payload
            });
        case DELETE_USER_TO_BILL_RESP:
            return Object.assign({}, state, {
                deleteUserToBillResp: action.payload
            });
        default:
            return state;
    }
}
